import { GraduationCap, Heart, Briefcase, BookOpen, Award, Building2, Rocket } from "lucide-react";

const PROFILE_TYPES = {
  team_member: {
    label: "Aspiritech Team Member",
    shortLabel: "Team Member",
    icon: Rocket,
    bgColor: "bg-emerald-500/15",
    textColor: "text-emerald-300",
    borderColor: "border-emerald-500/30",
    dotColor: "bg-emerald-400",
    gradient: "from-emerald-500/20 to-teal-500/10",
  },
  instructor: {
    label: "Academy Instructor",
    shortLabel: "Instructor",
    icon: BookOpen,
    bgColor: "bg-blue-500/15",
    textColor: "text-blue-300",
    borderColor: "border-blue-500/30",
    dotColor: "bg-blue-400",
    gradient: "from-blue-500/20 to-sky-500/10",
  },
  mentor: {
    label: "Career Mentor",
    shortLabel: "Mentor",
    icon: Heart,
    bgColor: "bg-purple-500/15",
    textColor: "text-purple-300",
    borderColor: "border-purple-500/30",
    dotColor: "bg-purple-400",
    gradient: "from-purple-500/20 to-violet-500/10",
  },
  jobseeker: {
    label: "Jobseeker",
    shortLabel: "Jobseeker",
    icon: Briefcase,
    bgColor: "bg-amber-500/15",
    textColor: "text-amber-300",
    borderColor: "border-amber-500/30",
    dotColor: "bg-amber-400",
    gradient: "from-amber-500/20 to-yellow-500/10",
  },
  participant: {
    label: "Academy Participant",
    shortLabel: "Participant",
    icon: GraduationCap,
    bgColor: "bg-cyan-500/15",
    textColor: "text-cyan-300",
    borderColor: "border-cyan-500/30",
    dotColor: "bg-cyan-400",
    gradient: "from-cyan-500/20 to-sky-500/10",
  },
  alumni: {
    label: "Academy Alumni",
    shortLabel: "Alumni",
    icon: Award,
    bgColor: "bg-indigo-500/15",
    textColor: "text-indigo-300",
    borderColor: "border-indigo-500/30",
    dotColor: "bg-indigo-400",
    gradient: "from-indigo-500/20 to-blue-500/10",
  },
  employer_partner: {
    label: "Employer Partner",
    shortLabel: "Employer",
    icon: Building2,
    bgColor: "bg-rose-500/15",
    textColor: "text-rose-300",
    borderColor: "border-rose-500/30",
    dotColor: "bg-rose-400",
    gradient: "from-rose-500/20 to-pink-500/10",
  },
};

export const ProfileBadge = ({ type, compact = false }) => {
  const config = PROFILE_TYPES[type];
  if (!config) return null;

  const Icon = config.icon;

  if (compact) {
    return (
      <span
        className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full border ${config.bgColor} ${config.textColor} ${config.borderColor}`}
        data-testid={`badge-${type}`}
      >
        <Icon className="w-3 h-3" />
        {config.shortLabel}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full border ${config.bgColor} ${config.textColor} ${config.borderColor} shadow-sm`}
      data-testid={`badge-${type}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dotColor} animate-pulse`} />
      <Icon className="w-3.5 h-3.5" />
      {config.label}
    </span>
  );
};

export const ProfileBadgeStrip = ({ type }) => {
  const config = PROFILE_TYPES[type];
  if (!config) return null;

  return (
    <div className={`h-1 w-full bg-gradient-to-r ${config.gradient} rounded-t-xl`} />
  );
};

export const PROFILE_TYPE_OPTIONS = Object.entries(PROFILE_TYPES).map(([value, config]) => ({
  value,
  label: config.label,
  icon: config.icon,
  textColor: config.textColor,
  bgColor: config.bgColor,
}));

export { PROFILE_TYPES };
